import { UseFormReturn, Path } from "react-hook-form";

/**
 * Generic helper to mark required field errors without triggering global toasts.
 * Returns how many fields were marked missing.
 */
export function applyRequiredFieldErrors<T extends Record<string, any>>(
  form: UseFormReturn<T>,
  values: T,
  checks: Array<{ key: Path<T>; message: string; isMissing: boolean }>
): number {
  let missing = 0;
  for (const { key, message, isMissing } of checks) {
    if (isMissing) {
      missing++;
      const state = form.getFieldState(key);
      if (!state.error) {
        form.setError(key, { type: "manual", message });
      }
    }
  }
  return missing;
}
